import React from "react"
import styled from "styled-components"
import Source from "../Source"
import { connect } from "react-redux"
import { AutoSuggest } from "buoy-core"
import { ButtonLink, Button } from "buoy-core"
import { captureException } from '../../common/error'
import { onSubmit as _onSubmit, onChange as _onChange } from "../handlers"
import QuestionReport from "./QuestionReport"

const InputWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
  height: 350px;
`

const Skip = styled(ButtonLink).attrs({
  color: "neutralDarkest",
  fontSize: "bodyMain",
})`
  margin-right: 32px;
`

const Actions = styled.div`
  margin: 6px 0 12px;
  height: 40px;
  display: flex;
`

class EmployerResponse extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      suggestions: [],
      active: -1,
      skipFocusBlur: false,
    }
  }

  componentDidMount() {
    if (typeof document !== 'undefined') {
      const input = document.getElementById('search-input')
      input.focus()
      input.addEventListener("keydown", this.keyDownInput, false);
    }
  }

  componentWillUnmount(){
    if (typeof document !== 'undefined') {
      const input = document.getElementById('search-input')
      input.removeEventListener("keydown", this.keyDownInput, false);
    }
  }

  keyDownInput = e => {
    let key = e.keyCode || e.which
    switch (key) {
      case 13: // Return
        e.preventDefault()
        e.stopPropagation()
        if (this.state.active >= 0) {
          this.handleSuggestionClick(this.state.suggestions[this.state.active].text)
        } else if (this.props.value.length > 1) {
          this.props.onSubmit()
        }
        break
      case 38: // Arrow up
        e.preventDefault()
        e.stopPropagation()
        this.decrement()
        break
      case 40: // Arrown down
        e.preventDefault()
        e.stopPropagation()
        this.increment()
        break 
      default:
        break
    }
  }

  increment() {
    if (this.state.suggestions.length) {
      let index = this.state.active >= this.state.suggestions.length-1 ? 0 : this.state.active + 1
      this.setState({ active: index })
    }
  }

  decrement() {
    if (this.state.suggestions.length) {
      let index = this.state.active <= 0 ? this.state.suggestions.length - 1 : this.state.active - 1
      this.setState({ active: index })
    }
  }

  handleChange = e => {
    e.preventDefault()
    e.stopPropagation()
    let query = e.target.value
    this.props.onChange(query)
    let terms = query.split(' ').join('+')
    Source.getEmployerNames(terms)
      .then(data => {
        let employers = [] 
        data.names.slice(0,5).forEach(name => employers.push({text: name, token: name}))
        this.setState({ suggestions: employers })
      })
      .catch(captureException)
  }

  handleSuggestionClick = name => {
    this.props.onChange(name)
    this.setState({
      suggestions: [],
      active: -1,
      skipFocusBlur: false,
    })
  }

  handleClear = e => {
    e.preventDefault()
    e.stopPropagation()
    this.props.onChange('')
    this.setState({ skipFocusBlur: false })
    document.getElementById('search-input').focus()
  }

  onMouseDown = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      skipFocusBlur: true,
    })
  }

  onBlur = e => {
    if (this.state.skipFocusBlur) return
    this.setState({ suggestions: [], active: -1 })
  }

  onFocus = e => {
    if (this.state.skipFocusBlur) return
    this.handleChange(e)
  }

  render() {
    // hides skip/submit when suggestions list awkwardly sort-of covers it
    let showSubmit = this.props.value.length === 0 || this.state.suggestions.length === 0
    return (
      <InputWrapper>
        <a hidden href="https://data.crunchbase.com/docs/2013-snapshot">Crunchbase 2013 Snapshot � 2013</a>
        <AutoSuggest
          placeholder={this.props.item.placeholder}
          suggestions={this.state.suggestions}
          suggestionClick={this.handleSuggestionClick}
          value={this.props.value}
          showCancel={false}
          selected={0}
          activeSuggestion={this.state.active}
          onChange={this.handleChange}
          onClear={this.handleClear}
          setListRef={() => () => true}
          setSuggestionRef={() => () => true}
          showDefaults={false}
          showSuggestionHeader={false}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onClearMouseDown={this.onMouseDown}
          onSuggestionMouseDown={this.onMouseDown}
        />
        {showSubmit && (
          <React.Fragment>
            <Actions>
              <Skip onClick={this.props.onSkip}>{this.props.item.skipText || "Skip"}</Skip>
              <Button disabled={!this.props.value} onClick={this.props.onSubmit}>
                Submit
              </Button>
            </Actions>
            <QuestionReport />
          </React.Fragment>
        )}
      </InputWrapper>
    )
  }
}

const mapStateToProps = state => ({
  value: state.integration.employer
})

const mapDispatchToProps = (dispatch, ownProps) => {
  const onSubmit = _onSubmit(ownProps.item, dispatch)
  const onChange = _onChange(ownProps.item, dispatch)

  return {
    onSubmit,
    onChange: name => onChange(name),
    onSkip: () => {
      onChange("")
      onSubmit()
    }
  }
}

const EmployerResponseWrapper = connect(mapStateToProps, mapDispatchToProps)(EmployerResponse)

export {EmployerResponseWrapper as default, EmployerResponse}



// WEBPACK FOOTER //
// ./assets/interview/components/EmployerResponse.js